import React from "react";
import { useState, useRef, useEffect, useCallback } from "react";
import { Modal, Button, ButtonGroup } from "react-bootstrap";
import AvatarEditor from "react-avatar-editor";
import ButtonIcon from "../base/ButtonIcon";
import ContainerNotResult from "../base/ContainerNotResult";
import { uploadImgS3 } from "../../utils/helpers";
import { ADD_LOGO_EMPRESA } from "../../utils/graphql_mutation";
import { useMutation } from "@apollo/client";
import LoadingButton from "../base/LoadingButton";

export default function UploadLogo({ empresaId, onClose, onSetLogo }) {
  const fileInput = useRef(null);
  const [image, setImage] = useState(null);
  const [scale, setScale] = useState(1);
  const [resul, setResul] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [response, setResponse] = useState({
    success: false,
    message: "",
  });
  
  const handleImageFile = useCallback((file) => {
    if (file && file.type.startsWith("image/")) {
      setImage(file);
    }
  }, []);

  useEffect(() => {
    const handlePaste = (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;
      
      for (let item of items) {
        if (item.type.startsWith("image/")) {
          const file = item.getAsFile();
          handleImageFile(file);
          break;
        }
      }
    };

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, [handleImageFile]);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleImageFile(file);
  };
  // MUTATION
  const [addLogoEmpresa] = useMutation(ADD_LOGO_EMPRESA);
  // FUNCTION
  const handleRegistrar = async () => {
    setLoading(true);
    try {
      const canvas = resul.getImageScaledToCanvas().toDataURL(`image/png`, 1);
      const res = await uploadImgS3({
        // base64: canvas,C
        //data.replace(/^data:image\/\w+;base64,/, "")

        data: Buffer.from(
          canvas.replace(/^data:image\/\w+;base64,/, ""),
          "base64"
        ),
        filename: "logo.png",
        prefix: "logo",
      });
      addLogoEmpresa({
        variables: {
          id: parseInt(empresaId),
          nombre_logo: res?.key,
        },
      });
      onSetLogo(res?.key);
      onClose();
    } catch (error) {
      console.log(error);
      setResponse({
        success: true,
        message: "Error al cargar logo de la empresa.",
      });
    }
    setLoading(false);
  };
  // RENDER
  return (
    <Modal show={true} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Cargar logo</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <input
          ref={fileInput}
          type="file"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
          style={{ display: "none" }}
        />
        {image ? (
          <>
            {response.success ? (
              <ContainerNotResult
                icon="fas fa-exclamation-triangle"
                mensaje={response.message}
                iconColor="danger"
              />
            ) : (
              <>
                <AvatarEditor
                  ref={(e) => setResul(e)}
                  width={400}
                  height={250}
                  image={image}
                  scale={scale}
                />
                <div className="text-center">
                  <ButtonIcon
                    titulo="Cargar"
                    variant="primary"
                    size="sm"
                    icono="fas fa-upload"
                    onClick={() => fileInput.current.click()}
                    className="float-left"
                    disabled={loading}
                  />
                  <ButtonGroup aria-label="Basic example" size="sm">
                    <ButtonIcon
                      titulo="Zoom"
                      variant="primary"
                      icono="fas fa-search-minus"
                      onClick={() => setScale(scale - 0.1)}
                      disabled={loading}
                    />
                    <ButtonIcon
                      titulo="Zoom"
                      variant="primary"
                      icono="fas fa-search-plus"
                      onClick={() => setScale(scale + 0.1)}
                      disabled={loading}
                    />
                  </ButtonGroup>
                </div>
              </>
            )}
          </>
        ) : (
          <div
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{
              border: isDragging ? "3px dashed #0d6efd" : "3px dashed #dee2e6",
              borderRadius: "8px",
              padding: "40px 20px",
              textAlign: "center",
              backgroundColor: isDragging ? "#f8f9fa" : "transparent",
              transition: "all 0.2s ease",
              cursor: "pointer",
            }}
            onClick={() => fileInput.current.click()}
          >
            <ContainerNotResult>
              <div className="mb-3">
                <i className={`fas fa-cloud-upload-alt fa-3x ${isDragging ? 'text-primary' : 'text-muted'}`}></i>
              </div>
              <p className="mb-2" style={{ fontSize: "14px", color: "#6c757d" }}>
                Arrastra una imagen aquí
              </p>
              <p className="mb-2" style={{ fontSize: "14px", color: "#6c757d" }}>
                o
              </p>
              <ButtonIcon
                text="Cargar imagen"
                variant="primary"
                icono="fas fa-upload"
              />
              <p className="mt-3 mb-0" style={{ fontSize: "12px", color: "#adb5bd" }}>
                También puedes pegar una imagen (Ctrl+V)
              </p>
            </ContainerNotResult>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        {image && !response.success && (
          <Button
            variant="primary"
            onClick={handleRegistrar}
            disabled={loading}
          >
            {loading && <LoadingButton />}
            Guardar
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
